import CommonService from "@/services/CommonService";
import CatalogService from "@/services/catalogService";
import { LoyaltyPointsService } from "@/services";

import { LoaderConfig } from "@/components/loader";

import { getAccessToken } from "../../util/storeHelper";
import {
  generateUUID,
  languageFromPathName,
  isServer,
  getCountryNameFromUrl,
  getVisitorId
} from "../../util";
import { handleFetchError } from "../../util/errorHandler";
import { getUserCountryStorage } from "../../util/browserStorage";

import { BEConfig, ENV_CONFIG } from "../../config/env";
import { fetchWebApi } from "../../webapis/apiResource";

import { getDataAsObject, retryCall } from "../../util/common";

import {
  SHOW_LOADER,
  HIDE_LOADER,
  CHANGE_LANGUAGE,
  COMMON_DATA,
  SET_BRANDS_DATA,
  RECENTLY_VIEWED,
  SET_STATES_DATA,
  SET_LOYALITY_POINTS,
  SET_SEARCH_TEXT,
  RESET_BRANDS_DATA,
  SHOW_ERROR_PAGE,
  HIDE_ERROR_PAGE,
  USER_ORIGIN_COUNTRY,
  SHOW_PAGE_LOADER,
  HIDE_PAGE_LOADER,
  SET_ORDER_COUNTRY,
  RESET_ORDER_STATE,
  SET_COUNTRIES_MOBILE_DETAILS,
  SET_SELECTED_COUNTRY_MOBILE_DETAILS,
  SET_LOYALTY_PROGRAM_STATUS,
  SET_DEVICE_TYPE,
  SET_CONFIG_SETTINGS,
  SET_IS_CHECKED_LOYALTY_PROGRAM,
  RECENTLY_VIEWED_PRODUCTS,
  SET_IS_SERVER_LOADED_REDUX_STATE,
  SET_IS_HEADER_FIXED,
  SET_COUNTRY_ID,
  SET_COUNTRY_FROM_URL,
  RESET_USER_ORIGIN_COUNTRY,
  SET_NATIONAL_CODE_MANDATORY_STATUS,
  SET_USER_AGENT
} from "../constants";
import {
  PRODUCT_CAROUSEL_ITEMS_LIMIT,
  DEFAULT_PAGE_LOADER_CONFIG
} from "../../constants";

import { setStoreList } from "./page.action";
import BrandsService, { Brand } from "../../services/brandsService";
import { AppDispatch } from "../store";

export const showErrorPage = (key, value) => ({
  type: SHOW_ERROR_PAGE,
  key,
  value
});

export const handleCountryId = (countryId: number) => ({
  type: SET_COUNTRY_ID,
  payload: countryId
});

export const hideErrorPage = () => ({ type: HIDE_ERROR_PAGE });

export const showLoadingIndicator = () => ({ type: SHOW_LOADER });

export const hideLoadingIndicator = () => ({ type: HIDE_LOADER });

export const showPageLoaderStart = payload => ({
  type: SHOW_PAGE_LOADER,
  payload
});

export const showPageLoaderEnd = payload => ({
  type: HIDE_PAGE_LOADER,
  payload
});

export const showPageLoader =
  (payload = {}) =>
  async dispatch => {
    dispatch(showPageLoaderStart(payload));
  };
export const hidePageLoader =
  (payload = {}) =>
  async dispatch => {
    dispatch(showPageLoaderEnd(payload));
  };

export const showLoaders =
  (pageLoaderConfig: LoaderConfig = DEFAULT_PAGE_LOADER_CONFIG) =>
  dispatch => {
    dispatch(showLoadingIndicator());
    dispatch(showPageLoader(pageLoaderConfig));
  };

export const hideLoaders =
  (pageLoaderConfig = DEFAULT_PAGE_LOADER_CONFIG) =>
  dispatch => {
    dispatch(hideLoadingIndicator());
    dispatch(hidePageLoader(pageLoaderConfig));
  };

export const updateLanguageName = name => ({
  type: CHANGE_LANGUAGE,
  name
});

export const setCommonData = settings => ({ type: COMMON_DATA, settings });

export const setCountryListData = countryData => ({
  type: COMMON_DATA,
  countryData
});

export const setBrandsData = (brands: Brand[]) => ({
  type: SET_BRANDS_DATA,
  brands
});
export const setSearchText = text => ({ type: SET_SEARCH_TEXT, text });

export const setStatesData = state => ({ type: SET_STATES_DATA, state });

export const setLoyaltyPoints = loyaltyPoints => ({
  type: SET_LOYALITY_POINTS,
  loyaltyPoints
});

export const setIsCheckedLoyaltyProgram = isCheckedLoyaltyProgram => ({
  type: SET_IS_CHECKED_LOYALTY_PROGRAM,
  isCheckedLoyaltyProgram
});

export const resetBrandsReducer = () => ({ type: RESET_BRANDS_DATA });

export const setUserOriginCountry = userOriginCountry => ({
  type: USER_ORIGIN_COUNTRY,
  userOriginCountry
});

export const resetUserOriginCountry = () => ({
  type: RESET_USER_ORIGIN_COUNTRY
});

export const resetOrderState = () => ({
  type: RESET_ORDER_STATE
});

export const setCountryFromUrl = countryShort => ({
  type: SET_COUNTRY_FROM_URL,
  payload: countryShort
});

export const setIsNationalCodeMandatoryStatus = isMandatory => ({
  type: SET_NATIONAL_CODE_MANDATORY_STATUS,
  payload: isMandatory
});

// export const toastMsg = (
//   toastType: TOAST_TYPES,
//   message: string,
//   noTitle: boolean,
//   time?: number
// ) => {
//   const toastConfig = toastNotificationOpts(
//     !noTitle && capitalize(toastType),
//     message,
//     time
//   );
//   const toastAction = toastType === TOAST_TYPES.SUCCESS ? success : error;

//   return dispatch => dispatch(toastAction(toastConfig));
// };

// TO DO: Remove after implementation new shape for all pages where we use it
export const setRecentlyViewed = product => {
  let recentLyViewed = localStorage.getItem(RECENTLY_VIEWED) as any;
  recentLyViewed = (recentLyViewed && getDataAsObject(recentLyViewed)) || [];
  if (!recentLyViewed.find(prod => prod.id === product.id)) {
    recentLyViewed.unshift(product);
    if (recentLyViewed.length > 12) {
      recentLyViewed.splice(12, recentLyViewed.length);
    }
    localStorage.setItem(RECENTLY_VIEWED, JSON.stringify(recentLyViewed));
  }
};

// TO DO: Remove after implementation new shape for all pages where we use it
export const getRecentlyViewed = () => {
  const recentlyViewed = localStorage.getItem(RECENTLY_VIEWED);
  return (recentlyViewed && getDataAsObject(recentlyViewed)) || [];
};

export const setRecentlyViewedProducts = product => {
  let recentLyViewed = localStorage.getItem(RECENTLY_VIEWED_PRODUCTS) as any;
  recentLyViewed = (recentLyViewed && getDataAsObject(recentLyViewed)) || [];
  if (!recentLyViewed.find(prod => prod.id === product.id)) {
    recentLyViewed.unshift(product);
    if (recentLyViewed.length > 12) {
      recentLyViewed.splice(12, recentLyViewed.length);
    }
    localStorage.setItem(
      RECENTLY_VIEWED_PRODUCTS,
      JSON.stringify(recentLyViewed)
    );
  }
};

export const getRecentlyViewedProducts = () => {
  const recentlyViewed = localStorage.getItem(RECENTLY_VIEWED_PRODUCTS);
  return (recentlyViewed && getDataAsObject(recentlyViewed)) || [];
};

export const getBrandsData = () => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await BrandsService.getBrandsData();

      dispatch(setBrandsData(response));

      return response;
    } catch (error) {
      handleFetchError(error, dispatch);
      return error.response;
    }
  };
};

export const getLoyaltyPoints =
  (orderItems, showLoader = false) =>
  async dispatch => {
    if (showLoader) dispatch(showLoadingIndicator());

    try {
      const loyaltyPoints = await LoyaltyPointsService.getLoyaltyPointsByCart(
        orderItems,
        "cart"
      );

      if (loyaltyPoints !== undefined)
        dispatch(setLoyaltyPoints(loyaltyPoints));

      return loyaltyPoints;
    } catch (error) {
      return error.response;
    } finally {
      if (showLoader) dispatch(hideLoadingIndicator());
    }
  };

const getLanguage = lang =>
  lang && lang.includes("ar") ? "arabic" : "english";

export const mapMobileDetails = countries =>
  countries.map(
    ({
      countryId,
      countrySHORT,
      mobileCountryCode,
      mobileLocalCode,
      mobileLocalNumberLength,
      countryName,
      mobileNumberCriteria
    }) => ({
      countryId,
      countrySHORT,
      mobileCountryCode,
      mobileLocalCode,
      mobileLocalNumberLength,
      countryName,
      mobileNumberCriteria
    })
  );

const getVersionedCommonApiBaseUrl = () => {
  const { protocol, baseURL, port, versionInfo } = BEConfig.commonApi;
  return `${protocol}${baseURL}${port}${versionInfo}`;
};

// Validate country code format (2-3 letters, case-insensitive)
const isValidCountryCode = (code: string): boolean => {
  if (!code || typeof code !== "string") return false;
  // Country codes are 2-3 letters (case-insensitive, e.g., ae, AE, sa, SA, uae, UAE)
  const countryCodePattern = /^[A-Z]{2,3}$/i;
  return countryCodePattern.test(code);
};

export const getCountrySettings = (language?, id?, url?) => {
  const lang = getLanguage(language);
  const shortCountryNameFromUrl = getCountryNameFromUrl(
    isServer ? url || `/${language}` : window.location.href
  );
  const countryFromCookies = (getUserCountryStorage() || "").toLowerCase();

  // Validate country code from URL before using it
  // If invalid, fall back to cookie or default country
  let countryIdentifier = id;
  if (!countryIdentifier && shortCountryNameFromUrl) {
    if (isValidCountryCode(shortCountryNameFromUrl)) {
      countryIdentifier = shortCountryNameFromUrl;
    } else {
      // Invalid country code from URL, log warning and use fallback
      if (isServer) {
        console.warn(
          `Invalid country code from URL: ${shortCountryNameFromUrl}, using fallback`
        );
      }
    }
  }

  // Use cookie country if URL country was invalid, or fall back to default
  countryIdentifier =
    countryIdentifier ||
    (countryFromCookies && isValidCountryCode(countryFromCookies)
      ? countryFromCookies
      : null) ||
    ENV_CONFIG.countryId;

  const { settingsHandle, countryByIdSetting } = BEConfig.commonApi;
  const apiURL = `${getVersionedCommonApiBaseUrl()}${settingsHandle}${countryByIdSetting}${countryIdentifier}?language=${lang}`;
  return (dispatch, getState) => {
    return fetchWebApi(getAccessToken(getState), apiURL, generateUUID())
      .then(response => {
        if (response.status === 200 && response.data) {
          const shapedData = [response.data];
          dispatch(setStoreList(lang, response.data.storeList));
          dispatch(setCountryListData(shapedData));
          response.data = shapedData;
        }
        return response;
      })
      .catch(error => {
        // Handle 500 errors gracefully - they're often caused by invalid country codes
        const errorStatus = error?.response?.status;
        if (errorStatus === 500) {
          const errorMessage =
            error?.response?.data?.message || "Internal server error";
          if (isServer) {
            console.warn(
              `500 error fetching country settings for: ${countryIdentifier} - ${errorMessage}`
            );
          }
          // Don't log full stack trace for expected 500 errors from invalid country codes
        }
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};

export const getOrderCountryById = (id, language) => {
  const lang = getLanguage(language);

  const { settingsHandle, countryByIdSetting } = BEConfig.commonApi;
  const apiURL = `${getVersionedCommonApiBaseUrl()}${settingsHandle}${countryByIdSetting}${id}?language=${lang}`;
  return (dispatch, getState) =>
    fetchWebApi(getAccessToken(getState), apiURL, generateUUID())
      .then(response => {
        if (response.status === 200 && response.data) {
          const shapedData = response.data;
          dispatch({ type: SET_ORDER_COUNTRY, payload: shapedData });
        }
        return response;
      })
      .catch(error => {
        handleFetchError(error, dispatch);
        return error.response;
      });
};

export const getCountryList = language => async (dispatch, getState) => {
  const lang = getLanguage(language);
  const { countryData } = getState().common;

  if (countryData.length > 1) return countryData;

  try {
    const countryDataList = await CommonService.getShortCountryList(lang);
    dispatch(setCountryListData(countryDataList));

    return countryDataList;
  } catch (error) {
    handleFetchError(error, dispatch);
    return error.response;
  }
};

export const getStatesData = (countryId, language = "en") => {
  const lang = languageFromPathName(language);
  const { statesHandle } = BEConfig.commonApi;
  const apiURL = `${getVersionedCommonApiBaseUrl()}${statesHandle}/${countryId}`;

  return (dispatch, getState) => {
    return retryCall({
      command: () =>
        fetchWebApi(getAccessToken(getState), apiURL, getVisitorId(), lang),
      delay: 500
    })
      .then(response => {
        if (response.status === 200 && response.data) {
          dispatch(setStatesData(response.data));
        }
        return response;
      })
      .catch(error => {
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};

export const setCountriesMobileDetails = details => ({
  type: SET_COUNTRIES_MOBILE_DETAILS,
  payload: details
});
export const setSelectedCountryMobileDetails = details => ({
  type: SET_SELECTED_COUNTRY_MOBILE_DETAILS,
  payload: details
});

export const getMobileDetailsFromCountryList = language => async dispatch => {
  try {
    const countries = await CommonService.getShortCountryList(
      getLanguage(language)
    );

    const details = mapMobileDetails(countries);
    dispatch(setCountriesMobileDetails(details));
    dispatch(setCountryListData(countries));
  } catch (error) {
    console.error(error);
  }
};

export const getCatalogCarouselData =
  ({ url, countryId, language, storeId }) =>
  async dispatch => {
    dispatch(showLoadingIndicator());

    try {
      const limit = PRODUCT_CAROUSEL_ITEMS_LIMIT;

      const response = await CatalogService.getCarouselData({
        url,
        countryId,
        language,
        storeId,
        limit
      });
      const { hits } = response;

      const carouselData = {
        enable: true,
        searchUrl: url,
        type: "product-carousel",
        [language]: { imageList: hits },
        queryId: response.queryID
      };

      return carouselData;
    } catch (error) {
      console.error("Call getCatalogCarouselData faced the error\n", error);
      return error.response;
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };

export const setDeviceType = type => ({
  type: SET_DEVICE_TYPE,
  payload: type
});

const setConfigurationSettings = configs => ({
  type: SET_CONFIG_SETTINGS,
  configs
});

export const getConfigurationSettings = () => async (dispatch, getState) => {
  const { protocol, baseURL, port, versionInfo, configurations } =
    BEConfig.catalogApi;
  const apiURL = `${protocol}${baseURL}${port}${versionInfo}${configurations}`;
  try {
    const response = await fetchWebApi(getAccessToken(getState), apiURL);

    if (response.status === 200 && response.data) {
      dispatch(setConfigurationSettings(response.data));
    }
    return response;
  } catch (error) {
    handleFetchError(error, dispatch);
    return error.response;
  }
};

export const setIsServerLoadedReduxState = state => ({
  type: SET_IS_SERVER_LOADED_REDUX_STATE,
  payload: state
});

export const setIsHeaderFixed = isHeaderFixed => ({
  type: SET_IS_HEADER_FIXED,
  isHeaderFixed
});

export const setUserAgent = userAgent => ({
  type: SET_USER_AGENT,
  payload: userAgent
});
